import React, { Context, createContext, PropsWithChildren, useCallback, useContext, useEffect, useState } from 'react'
import { callApi, TApiResponse } from '../api'
import { ILanguage, ILanguageState, TLanguageActions } from '../types'

/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */

const initialLanguageState: ILanguageState = {
	languages: [],
	loading: false,
}

const LanguageContext: Context<{
	languages: ILanguageState
	actions: TLanguageActions
}> = createContext({
	languages: initialLanguageState,
	actions: {
		// tslint:disable-next-line: no-empty
		allLists: () => {},
	},
})

export const LanguageProvider = (props: PropsWithChildren<{}>) => {
	const [loading, setLoading] = useState<boolean>(false)
	const [error, setProviderError] = useState<string | null>(null)
	const [languages, setLanguages] = useState<ILanguage[]>([])

	const fetchLanguages = async () => {
		setLoading(true)
		const languagesResponse: TApiResponse = await callApi('/languages', {})

		const { data } = languagesResponse.payload

		if (languagesResponse.ok) {
			setLoading(false)
			setProviderError(null)
			setLanguages(data.languages)
		} else {
			setLoading(false)
			setProviderError(data.message || 'Cannot get Languages!')
		}
	}

	const allLists = useCallback(fetchLanguages, [])
	const actions: TLanguageActions = { allLists }

	useEffect(() => actions.allLists(), [])

	return (
		<LanguageContext.Provider value={{ languages: { languages, loading, error }, actions }}>
			{props.children}
		</LanguageContext.Provider>
	)
}

export const useLanguageContext: () => {
	languages: ILanguageState
	actions: TLanguageActions
} = () => {
	return useContext(LanguageContext)
}
